import { render, staticRenderFns } from "./CartTotals.vue?vue&type=template&id=118deaa1&"
import script from "./CartTotals.vue?vue&type=script&lang=js&"
export * from "./CartTotals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports